import { createContext } from "react";

export const FriendsViewContext = createContext();

